import { Link } from 'react-router-dom'
import { QuestCategoryCard } from 'summon-ui'
import useQuests from '@features/quests/hooks/useQuests'
import { Category } from '@generated/generates'
import useAuth from '@hocs/useAuth'
import { resolveVariant } from '@utils/questsHelpers'

interface Props {
  category: Category
}

const CategoryCard = ({ category }: Props) => {
  const { id, name, description, imageUrl } = category
  const { quests } = useQuests({ categoryId: id })
  const { finishedAuthenticating } = useAuth()
  const questVariant = resolveVariant(category?.completionPercentage || 0)

  const Card = (
    <QuestCategoryCard
      {...(finishedAuthenticating ? { variant: questVariant } : {})}
      key={id}
      name={name}
      {...(category?.completionPercentage ? { completionPercentage: category?.completionPercentage } : {})}
      description={description || ''}
      imgUrl={imageUrl ?? undefined}
    />
  )

  // TODO: We need to check if the category has length until we have a way to disable a Category safely in admin portal
  return quests?.length > 0 ? (
    <Link key={id} to={`${id}`}>
      {Card}
    </Link>
  ) : null
}

export default CategoryCard
